import Cookies from 'js-cookie'
const GetCookie =(cookiename)=> Cookies.get(cookiename)
export default GetCookie